import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/serie-form.schema';
import { useCreateSeriesMutation } from '../mutations';
import { SerieForm } from './components/serie-form';
import { useNavigate } from 'react-router';
import { Fragment } from 'react/jsx-runtime';
import { toast } from 'react-toastify';

export function Page() {
  const mutation = useCreateSeriesMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync(payload), {
      success: 'Serien har skapats',
      pending: 'Skapar serien...',
    });
    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa serie" />

      <PageLayout.Section>
        <SerieForm onSubmit={onSubmit} isLoading={mutation.isPending} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
}
